export const avis = [
  {
    nom: "Claire D.",
    ville: "",
    texte:
      "Travail impeccable et équipe très professionnelle. Notre jardin a complètement changé d'apparence.",
  },
  {
    nom: "Marc T.",
    ville: "",
    texte:
      "Ponctuels, soigneux et de très bon conseil. La haie n'a jamais été aussi bien taillée.",
  },
  {
    nom: "Sophie L.",
    ville: "",
    texte:
      "Un accompagnement vraiment personnalisé : ils ont su comprendre ce que nous voulions pour notre jardin.",
  },
  {
    nom: "Julien R.",
    ville: "",
    texte:
      "Intervention rapide pour la remise en état de notre terrain. Résultat au-delà de nos attentes.",
  },
  {
    nom: "Nathalie B.",
    ville: "",
    texte:
      "Le contrat d'entretien annuel nous change la vie : nous profitons enfin de notre extérieur sans contrainte.",
  },
  {
    nom: "Philippe M.",
    ville: "",
    texte:
      "Devis clair, travail net et finitions soignées. Je recommande sans hésiter.",
  },
];

export const avisNote = "Avis de démonstration — à remplacer par de vrais avis clients.";
